export default "__VITE_ASSET__DYwK7fE$__"